import { getNamespaced } from '@/store/utils';

/* eslint-disable import/prefer-default-export, key-spacing */
export const global = {
  addProcess:               'ADD_PROCESS',
  removeProcess:            'REMOVE_PROCESS',
  setPanelOpen:             'SET_PANEL_OPEN',
  togglePanelOpen:          'TOGGLE_PANEL_OPEN',
  setPanelManuallyToggled:  'SET_PANEL_MANUALLY_TOGGLED',
  setError:                 'SET_ERROR',
};

export const session = {
  setToken: 'SET_TOKEN',
};

export const googlemap = {
  setMap:           'SET_MAP',
  setOverlays:      'SET_OVERLAYS',
  addOverlay:       'ADD_OVERLAY',
  editOverlay:      'EDIT_OVERLAY',
  removeOverlay:    'REMOVE_OVERLAY',
  setMarkerData:    'SET_MARKER_DATA',
  setMarkers:       'SET_MARKERS',
  addMarker:        'ADD_MARKER',
  editMarker:       'EDIT_MARKER',
  removeMarker:     'REMOVE_MARKER',
  setDirty:         'SET_DIRTY',
};
export const googlemapNS = getNamespaced('googlemap', googlemap);

export const distributor = {
  setDealerList:          'SET_DEALER_LIST',
  setDealersToDraw:       'SET_DEALERS_TO_DRAW',
  addDealerToDraw:        'ADD_DEALER_TO_DRAW',
  removeDealerToDraw:     'REMOVE_DEALER_TO_DRAW',
  removeDefaultRegion:    'REMOVE_DEFAULT_REGION',
  addRegionToDealer:      'ADD_REGION_TO_DEALER',
  editRegionOnDealer:     'EDIT_REGION_ON_DEALER',
  removeRegionFromDealer: 'REMOVE_REGION_FROM_DEALER',
  setDealersToMark:       'SET_DEALERS_TO_MARK',
  addDealertoMark:        'ADD_DEALER_TO_MARK',
  removeDealerToMark:     'REMOVE_DEALER_TO_MARK',
  setFocusedDealer:       'SET_FOCUSED_DEALER',
};

export const distributorNS = getNamespaced('distributor', distributor);



// WEBPACK FOOTER //
// ./src/store/types/mutations.js